import StorageIcon from '@material-ui/icons/Storage';
import ContactsOutlinedIcon from '@material-ui/icons/ContactsOutlined';
import AssignmentIcon from '@material-ui/icons/Assignment';
import {
    handleSelfReturn, 
    handleStorageScanManagement,
    handleDriverPickup,
    handlePodQualityManagement,
    handlePreAlertQuery 
} from '../../../reducers/uiSlice';
import { HowToVote, PersonPin } from '@material-ui/icons';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import PhotoFilterIcon from '@material-ui/icons/PhotoFilter';
import EditLocationIcon from '@material-ui/icons/EditLocation';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import BuildOutlinedIcon from '@material-ui/icons/BuildOutlined';
import ForwardIcon from '@material-ui/icons/Forward';

const iconStyle = {
    fontSize: 32, 
    margin: 12
}

export const managementMenuItems = [
    {
        id:"menu-slot-assignment",
        link: "/slot-assignment",
        icon: <AssignmentIcon style={iconStyle}/>,
        title: 'slot_assignment',
        access_ability_id: 17
    },{
        id:"menu-storage-scan",
        dispatchFunction: handleStorageScanManagement(true),
        icon: <StorageIcon style={iconStyle}/>,
        title: 'storage_scan',
        access_ability_id: 18
    }
    // ,{
    //     id:"menu-self-return",
    //     dispatchFunction: handleSelfReturn(true),
    //     icon: <ContactsOutlinedIcon style={iconStyle}/>,
    //     title: 'self_return',
    //     access_ability_id: 21
    // }
    ,{
        id: "menu-user-management-new",
        link: "/user-management",
        icon: <PersonPin style={iconStyle}/>,
        title: "user_management_new",
        access_ability_id: 29
    },{
        id:"menu-incident-management",
        link: "/incident-management",
        icon: <HowToVote style={iconStyle}/>,
        title: 'incident_management',
        access_ability_id: 31
    },{
        id:"menu-pod-quality-management",
        dispatchFunction: handlePodQualityManagement(true),
        icon: <PhotoFilterIcon style={iconStyle}/>,
        title: 'pod_quality_management',
        access_ability_id: 32
    },
    {
        id:"menu-driver-pickup",
        dispatchFunction: handleDriverPickup(true),
        icon: <PlaylistAddCheckIcon style={iconStyle}/>,
        title: 'driver_pickup',
        access_ability_id: 33
    },{
        id:"menu-delivery-area-management",
        link: "/delivery-area-management",
        icon: <EditLocationIcon style={iconStyle}/>,
        title: 'delivery_area_management',
        access_ability_id: 34
    },{
        id:"pre-alert-query",
        dispatchFunction: handlePreAlertQuery(true),
        icon: <NoteAddIcon style={iconStyle}/>,
        title: 'pre-alert-query',
        access_ability_id: 30
    },{
        id:"wrong-address-tool",
        link: "/wrong-address-tool",
        icon: <BuildOutlinedIcon style={iconStyle}/>,
        title: 'wrong_address_tool',
        access_ability_id: 37
    },{
        id:"order-forward-tool",
        link: "/order-forward-tool",
        icon: <ForwardIcon style={iconStyle}/>,
        title: 'order_forward_tool',
        access_ability_id: 38
    }
]
